import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadDiscussion: IDiscussionLoadActionCreator = (projectId) => {
        return {
            type: ACTION_DISCUSSION_LOAD,
            projectId
        }
    },
    LoadDiscussionById: IDiscussionLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_DISCUSSION_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IDiscussionLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_DISCUSSION_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IDiscussionLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_DISCUSSION_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveDiscussion: IDiscussionSaveActionCreator = (formData) => {
        return {
            type: ACTION_DISCUSSION_SAVE,
            formData
        }
    },
    SaveSuccess: IDiscussionSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_DISCUSSION_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IDiscussionSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_DISCUSSION_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateDiscussion: IDiscussionCreateActionCreator = (projectId) => {
        return {
            type: ACTION_DISCUSSION_CREATE,
            projectId
        }
    },
    CreateSuccess: IDiscussionCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_DISCUSSION_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IDiscussionCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_DISCUSSION_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateDiscussion: IDiscussionValidateActionCreator = (formData) => {
        return {
            type: ACTION_DISCUSSION_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IDiscussionValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_DISCUSSION_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IDiscussionValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_DISCUSSION_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IDiscussionClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_DISCUSSION_CLEAR,
            propertiesToClear
        }
    },

    Filter: IDiscussionFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_DISCUSSION_FILTER,
            formFilter
        }
    };



export const
    ACTION_DISCUSSION_LOAD = "ACTION_DISCUSSION_LOAD",
    ACTION_DISCUSSION_LOAD_BY_ID = "ACTION_DISCUSSION_LOAD_BY_ID",
    ACTION_DISCUSSION_LOAD_SUCCESS = "ACTION_DISCUSSION_LOAD_SUCCESS",
    ACTION_DISCUSSION_LOAD_FAILURE = "ACTION_DISCUSSION_LOAD_FAILURE",

    ACTION_DISCUSSION_SAVE = "ACTION_DISCUSSION_SAVE",
    ACTION_DISCUSSION_SAVE_SUCCESS = "ACTION_DISCUSSION_SAVE_SUCCESS",
    ACTION_DISCUSSION_SAVE_FAILURE = "ACTION_DISCUSSION_SAVE_FAILURE",

    ACTION_DISCUSSION_CREATE = "ACTION_DISCUSSION_CREATE",
    ACTION_DISCUSSION_CREATE_SUCCESS = "ACTION_DISCUSSION_CREATE_SUCCESS",
    ACTION_DISCUSSION_CREATE_FAILURE = "ACTION_DISCUSSION_CREATE_FAILURE",

    ACTION_DISCUSSION_VALIDATE = "ACTION_DISCUSSION_VALIDATE",
    ACTION_DISCUSSION_VALIDATE_SUCCESS = "ACTION_DISCUSSION_VALIDATE_SUCCESS",
    ACTION_DISCUSSION_VALIDATE_FAILURE = "ACTION_DISCUSSION_VALIDATE_FAILURE",

    ACTION_DISCUSSION_CLEAR = "ACTION_DISCUSSION_CLEAR",

    ACTION_DISCUSSION_FILTER = "ACTION_DISCUSSION_FILTER";

export interface IDiscussionLoadAction {
    type: "ACTION_DISCUSSION_LOAD";
    projectId: number;
}

export interface IDiscussionLoadActionCreator {
    (projectId: number): IDiscussionLoadAction;
}

export interface IDiscussionLoadSuccessAction {
    type: "ACTION_DISCUSSION_LOAD_SUCCESS";
    formData: Dtos.Discussion | Dtos.Discussion[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IDiscussionLoadSuccessActionCreator {
    (
        formData: Dtos.Discussion | Dtos.Discussion[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IDiscussionLoadSuccessAction;
}

export interface IDiscussionLoadFailureAction {
    type: "ACTION_DISCUSSION_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IDiscussionLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IDiscussionLoadFailureAction;
}

export interface IDiscussionLoadByIdAction {
    type: "ACTION_DISCUSSION_LOAD_BY_ID";
    id: number;
}

export interface IDiscussionLoadByIdActionCreator {
    (id: number): IDiscussionLoadByIdAction;
}

export interface IDiscussionSaveAction {
    type: "ACTION_DISCUSSION_SAVE";
    formData: Dtos.Discussion;

}

export interface IDiscussionSaveActionCreator {
    (
        formData: Dtos.Discussion
    ): IDiscussionSaveAction;
}

export interface IDiscussionSaveSuccessAction {
    type: "ACTION_DISCUSSION_SAVE_SUCCESS";
    formData: Dtos.Discussion;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IDiscussionSaveSuccessActionCreator {
    (
        formData: Dtos.Discussion,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IDiscussionSaveSuccessAction;
}

export interface IDiscussionSaveFailureAction {
    type: "ACTION_DISCUSSION_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IDiscussionSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IDiscussionSaveFailureAction;
}

export interface IDiscussionCreateAction {
    type: "ACTION_DISCUSSION_CREATE",
    projectId: number
}

export interface IDiscussionCreateActionCreator {
    (projectId: number): IDiscussionCreateAction
}

export interface IDiscussionCreateSuccessAction {
    type: "ACTION_DISCUSSION_CREATE_SUCCESS";
    formData: Dtos.Discussion;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IDiscussionCreateSuccessActionCreator {
    (
        formData: Dtos.Discussion,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IDiscussionCreateSuccessAction;
}

export interface IDiscussionCreateFailureAction {
    type: "ACTION_DISCUSSION_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IDiscussionCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IDiscussionCreateFailureAction;
}

export interface IDiscussionValidateAction {
    type: "ACTION_DISCUSSION_VALIDATE";
    formData: Dtos.Discussion;

}

export interface IDiscussionValidateActionCreator {
    (
        formData: Dtos.Discussion
    ): IDiscussionValidateAction;
}

export interface IDiscussionValidateSuccessAction {
    type: "ACTION_DISCUSSION_VALIDATE_SUCCESS";
    formData: Dtos.Discussion;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IDiscussionValidateSuccessActionCreator {
    (
        formData: Dtos.Discussion,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IDiscussionValidateSuccessAction;
}

export interface IDiscussionValidateFailureAction {
    type: "ACTION_DISCUSSION_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IDiscussionValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IDiscussionValidateFailureAction;
}

export interface IDiscussionClearAction {
    type: "ACTION_DISCUSSION_CLEAR";
    propertiesToClear?: string[];
}

export interface IDiscussionClearActionCreator {
    (propertiesToClear?: string[]): IDiscussionClearAction;
}

export interface IDiscussionFilterActionCreator {
    (formFilter: IFormFilter): IDiscussionFilterAction;
}

export interface IDiscussionFilterAction {
    type: "ACTION_DISCUSSION_FILTER";
    formFilter: IFormFilter;
}


export type DiscussionAction =
    IDiscussionLoadAction |
    IDiscussionLoadByIdAction |
    IDiscussionLoadFailureAction |
    IDiscussionLoadSuccessAction |
    IDiscussionSaveAction |
    IDiscussionSaveSuccessAction |
    IDiscussionSaveFailureAction |
    IDiscussionCreateAction |
    IDiscussionCreateSuccessAction |
    IDiscussionCreateFailureAction |
    IDiscussionValidateAction |
    IDiscussionValidateSuccessAction |
    IDiscussionValidateFailureAction |
    IDiscussionClearAction | 
    IDiscussionFilterAction;
